<template>
  <div class="container">
      <div class="header">
        <div class="nav">
          <ul>
            <router-link to="/home"><li>首页</li></router-link>
            <router-link to="/about"><li class="navLi">关于心动好物</li></router-link>
            <router-link to="/contact"><li>联系我们</li></router-link>
            <router-link to="/charge"><li>收费资讯</li></router-link>
            <registerModule></registerModule>
          </ul>
        </div>
        <div class="peopleIntro">
<!--          <img src="@/assets/img/peopleIntro.png" alt="">-->
        </div>
      </div>
<!--      <div class="intro">-->
<!--          <div class="imgIntro">-->
<!--              <div class="aboutOur">-->
<!--                <img src="@/assets/img/aboutOurIcon.png" alt="">-->
<!--              </div>-->
<!--              <p class="imgTitle">关于我们</p>-->
<!--              <p class="imgContent">-->
<!--                品牌代言人-->
<!--                王晓芳-->
<!--                职场身价管理教练，壹创新商学创始人-->
<!--                致力于为每一个客户甄选心动好物-->
<!--                科技好物，就是心动好物-->
<!--              </p>-->
<!--          </div>-->
<!--        <div class="imgIntro">-->
<!--          <div class="mission">-->
<!--            <img src="@/assets/img/missionIcon.png" alt="">-->
<!--          </div>-->
<!--          <p class="imgTitle">使命</p>-->
<!--          <p class="imgContent">-->
<!--            壹创新致力于为职场人提供终身成长方案，为企业提供创新增长系统，构建全球最强创新增长联盟，助力中国企业引领世界。-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="intro lastIntro">-->
<!--        <div class="imgIntro">-->
<!--          <div class="vision">-->
<!--            <img src="@/assets/img/visionIcon.png" alt="">-->
<!--          </div>-->
<!--          <p class="imgTitle">愿景</p>-->
<!--          <p class="imgContent">-->
<!--            做职场人最喜爱、最需要的学习成长平台！-->
<!--          </p>-->
<!--        </div>-->
<!--        <div class="imgIntro">-->
<!--          <div class="slogan">-->
<!--            <img src="@/assets/img/sloganIcon.png" alt="">-->
<!--          </div>-->
<!--          <p class="imgTitle">口号</p>-->
<!--          <p class="imgContent">-->
<!--            壹创新，一切为了增长！-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
      <div class="course">
        <div class="item">
          <div>
            <img src="@/assets/img/xueshe.png" alt="">
          </div>
<!--          <p class="itemContent">学商学就是学赚钱</p>-->
        </div>
        <div class="item">
          <div>
            <img src="@/assets/img/chengzhang.png" alt="">
          </div>
<!--          <p class="itemContent">一本书一门课，走向卓越职场人的必修课</p>-->
        </div>
        <div class="item">
          <div>
            <img src="@/assets/img/21.png" alt="">
          </div>
<!--          <p class="itemContent">10分钟掌握1个创新营销案例</p>-->
        </div>
      </div>
<!--      <div class="course2">-->
<!--        <div class="item">-->
<!--          <div>-->
<!--            <img src="@/assets/img/guanli.png" alt="">-->
<!--          </div>-->
<!--          <p class="itemContent">解决日常管理中的30个难题，让你从管理小白到管理大神</p>-->
<!--        </div>-->
<!--        <div class="item">-->
<!--          <div>-->
<!--            <img src="@/assets/img/meiri.png" alt="">-->
<!--          </div>-->
<!--          <p class="itemContent">商业概念创意解读</p>-->
<!--        </div>-->
<!--        <div class="item">-->
<!--          <div>-->
<!--            <img src="@/assets/img/tingshu.png" alt="">-->
<!--          </div>-->
<!--          <p class="itemContent">30天30本总裁必听创新书</p>-->
<!--        </div>-->
<!--      </div>-->
      <bottom></bottom>
  </div>
</template>

<script>
    import bottom from '@/components/bottom.vue'
    import registerModule from "@/components/registerModule.vue";

    export default {
        name: "about",
        components:{bottom, registerModule}
    }
</script>

<style scoped>
  .header{
    height:910px;
    background:url(../../assets/img/about1920-910.png) no-repeat center center;
    background-size:100% 100%;
    padding-top:25px;
    position:relative;
  }
  /*.nav{*/
  /*  height:65px;*/
  /*  margin-right:323px;*/
  /*}*/
  .nav{
    width:100%;
    height:150px;
    border: 0px solid red;
    margin:0 auto;
    background:url(../../assets/img/logoLine.png) no-repeat 230px 70px;
    background-size:268px 54px;
    padding-right:323px;
  }
  .nav ul{
    height:70px;
    display:flex;
    justify-content:flex-end;
    align-items:center;
  }
  .nav ul li{
    font-size:18px;
    color:#221815;
    font-weight:600;
    padding:13px 35px;
    margin-right:20px;
    font-family:'PingFang Bold';
  }
  .navLi{
    border:1px solid rgba(34, 24, 21, 0.5);
    border-radius:20px;
  }
  .peopleIntro{
    position:absolute;
    left:382px;
    top:300px;
  }
  .peopleIntro img{
    width:642px;
    height:355px;
  }
  .intro{
    margin-top:90px;
    margin-bottom:86px;
    display:flex;
    justify-content:center;
    align-items:center;
  }
  .lastIntro{
    margin-bottom:165px;
  }
  .imgIntro{
     width:541px;
     margin-right:60px;
  }
  .imgIntro:last-child{
    margin-right:5px;
  }
  .aboutOur, .mission, .vision, .slogan{
    width:80px;
    height:80px;
  }
  .aboutOur img{
    width:70px;
    height:68px;
  }
  .mission img{
    width:63px;
    height:71px;
  }
  .vision img{
    width:66px;
    height:72px;
  }
  .slogan img{
    width:68px;
    height:60px;
  }
  .imgTitle{
    margin:16px 0 44px 0;
    font-family: 'PingFang Bold';
    font-size:28px;
    color:#3B3D40;
  }
  .imgContent{
    font-family: 'PingFang Light';
    font-weight:600;
    font-size:24px;
    color:#656B6F;
    letter-spacing:2px;
    line-height:35px;
  }
  .course{
    height:350px;
    display:flex;
    justify-content:center;
    align-items:center;
    background-color: #FAFCFE;
    background-size:100% 340px;
  }
  .course2{
    width:100%;
    /*height:755px;*/
    margin-bottom:120px;
    display:flex;
    justify-content:center;
    align-items:center;
  }
  .item{
    width:384px;
    height:285px;
    margin-top:6px;
    margin-right:35px;
    -webkit-border-radius:2px;
    -moz-border-radius:2px;
    border-radius:2px;
  }
  .course2 .item{
    margin-top:0px;
  }
  .item:hover{
    -moz-box-shadow:0px 4px 4px rgba(199, 227, 230, 0.35);
    -webkit-box-shadow:0px 4px 4px rgba(199, 227, 230, 0.35);
    box-shadow:0px 4px 4px rgba(199, 227, 230, 0.35);
  }
  .item:last-child{
    margin-right:0px;
  }
  .item img{
    width:384px;
    height:285px;
  }
  .itemContent{
    margin-top:44px;
    font-family: 'PingFang Light';
    font-weight:600;
    font-size:24px;
    color:#656B6F;
    letter-spacing:1px;
    line-height:34px;
    padding:11px 15px 0 14px;
  }
  </style>



// WEBPACK FOOTER //
// src/pages/about/about.vue